import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form } from "react-final-form";
import * as yup from "yup";
import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import {
     UiButton,
     UiToggleButton,
} from "../../../_uiComponents/common/form/UiButton";
import UiInnerSearchWr from "../../../_uiComponents/common/UiInnerSearchWr";
import UiDropDownList from '../../../_uiComponents/telerikComponents/UiDropDownList'
import UiDatePicker from '../../../_uiComponents/telerikComponents/UiDatePicker'
import Validator from "../../../../_helpers/validate.schema";


const validateSchema = () =>
     yup.object().shape({
          // salesFileType: yup.object().required("Sales File Type is required."),
          // salesDate: yup.string().required("Sales date is required."),
          // status: yup.object().required("Status is required.")

     });

const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

const onSubmit = async (values) => {
     console.log(values)
}


const salesFileType = [
     {
          label: "File Type 1",
          value: 1,
     },
     {
          label: "File Type 2",
          value: 2,
     },
     {
          label: "File Type 3",
          value: 3,
     }

];

const statusData = [
     {
          label: "Approved",
          value: 1,
     },
     {
          label: "Not Approved",
          value: 2,
     }

];
export default function SalesDataManagementFilterForm(props) {

     return (
          <>
               <Form
                    validate={onValidate}
                    onSubmit={onSubmit}
                    render={({ handleSubmit, reset, submitting, pristine, values, valid }) => (
                         <form onSubmit={validateSchema} className="sba-telerik-components-wr">
                              <UiInnerSearchWr>
                                   <Grid container spacing={2}>
                                        <Grid item xs={12} lg={9}>
                                             <Grid container spacing={2}>
                                                  <Grid
                                                       item
                                                       xs={12}
                                                       lg={4}
                                                       className="sba-search-input"
                                                  >
                                                       <UiDropDownList
                                                            name="salesFileType"
                                                            label="Sales File Type"
                                                            placeholder="Select File Type"
                                                            data={salesFileType} />
                                                  </Grid>

                                                  <Grid
                                                       item
                                                       xs={12}
                                                       lg={4}
                                                  >
                                                       <UiDatePicker
                                                            label="Sales Date"
                                                            name="salesDate"
                                                            placeholder="Sales Date" />
                                                  </Grid>

                                                  <Grid
                                                       item
                                                       xs={12}
                                                       lg={4}
                                                  >
                                                       <UiDropDownList
                                                            name="status"
                                                            label="Status"
                                                            placeholder="Select Status"
                                                            data={statusData} />

                                                  </Grid>

                                             </Grid>
                                        </Grid>
                                        <Grid item xs={12} lg={3}>
                                             <Stack
                                                  spacing={2}
                                                  direction="row"
                                                  justifyContent="end"
                                                  sx={{
                                                       width: "100%",
                                                       pt: 0.6,
                                                  }}
                                             >
                                                  <UiButton
                                                       name="Clear"
                                                       variant="outlined"
                                                       size="small"

                                                  />
                                                  <UiButton
                                                       name="Apply"
                                                       variant="contained"
                                                       size="small"
                                                       onClick={
                                                            handleSubmit
                                                       }
                                                  />
                                             </Stack>
                                        </Grid>
                                   </Grid>
                              </UiInnerSearchWr>
                         </form>
                    )} />
          </>


     );
}
